import React, { useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import OrderController from '../controller/OrderController';

const OrderCancel = () => {
  const [password, setPassword] = useState('');
  const params = useParams<{ orderId: string; orderSeq: any }>();
  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const orderCancel = async () => {
    if (password === '0322') {
      try {
        const data = {
          order_id: params.orderId,
          order_seq: Number(params.orderSeq),
        };
        const oRes = await OrderController.setOrderCancel(data);
        if (oRes && oRes.data) {
          const oResponse = oRes.data;

          if (oResponse.data && oResponse.ok) {
            if (oResponse.data.success) {
              alert('주문 강제 취소 완료');
            } else {
              alert(oResponse.data.msg);
            }
          }
        }
      } catch (err) {
        console.log('err---->', err);
      }
    } else {
      alert('비밀번호 오류');
    }
  };

  return (
    <Style>
      <div className="wrap">
        <h2>비밀번호를 입력해주세요.</h2>
        <input type="text" value={password} onChange={handlePasswordChange} />
        <button onClick={orderCancel}>확인</button>
      </div>
    </Style>
  );
};

export default OrderCancel;

export const Style = styled.div`
  .wrap {
    padding: 5vh 5vw;
  }

  input {
    margin-top: 10px;
    padding: 6px 12px;
  }
  button {
    background: #000;
    color: #fff;
    padding: 8px 12px;
    border-radius: 4px;
    margin-left: 12px;
  }
`;
